import { useTranslation } from 'react-i18next';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { TopBar } from '@/components/layout/TopBar';
import { OnboardingPassportPage } from '@/pages/onboarding/passport';

export function SettingsPassportEditPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <AppShell>
      <PageContainer>
        <TopBar back title={t('passport.edit_title')} />
        {/* re-use the same form; success returns to home flow */}
        <OnboardingPassportPage />
      </PageContainer>
    </AppShell>
  );
}
